import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

const ServicesCTA = ({ image, text, buttonText }) => {
  const imageData = getImage(image)
  //parse the contents of the rich-text data
  const bodyCopy = JSON.parse(text.raw)

  return (
    <section className="bg-cream ">
      <div className="pt-10 md:py-32 md:container">
        <div className="lg:flex lg:items-center">
          <div className="px-4 mb-12 border-l-4 lg:mb-0 md:pl-6 lg:w-1/2 lg:pr-16 md:border-navy">
            <div className="mb-12">{documentToReactComponents(bodyCopy)}</div>
            <button
              className={`pl-12 pr-6 py-3 bg-navy text-pink-50 tracking-widest hover:opacity-90`}
            >
              <Link to={`/services/`} className="uppercase flex items-center">
                {buttonText}
                <svg
                  width="800px"
                  height="800px"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`w-6 h-6 ml-2`}
                >
                  <path
                    d="M10 16L14 12L10 8"
                    stroke="#fff"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </Link>
            </button>
          </div>
          <div className="lg:w-1/2">
            <GatsbyImage image={imageData} alt={image.title} fit="contain" />
          </div>
        </div>
      </div>
    </section>
  )
}
export default ServicesCTA
